import React from 'react';
import { Check, Target } from 'lucide-react';
import { siteData } from '../data/mock';

const MissionSection = () => {
  return (
    <section id="mission" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Image Side */}
          <div className="relative">
            <div className="relative z-10">
              <img
                src={siteData.images.community}
                alt="Community solidarity"
                className="rounded-2xl shadow-2xl w-full h-[500px] object-cover"
              />
            </div>
            
            {/* Decorative Elements */}
            <div className="absolute -top-6 -left-6 w-full h-full border-2 border-emerald-200 rounded-2xl" />
            <div className="absolute -bottom-8 -right-8 w-48 h-48 bg-amber-100 rounded-2xl -z-10" />
            
            {/* Floating Card */}
            <div className="absolute -bottom-6 left-6 bg-white rounded-xl shadow-xl p-6 z-20">
              <div className="flex items-center gap-4">
                <div className="w-14 h-14 rounded-full bg-emerald-100 flex items-center justify-center">
                  <Target className="w-7 h-7 text-emerald-600" />
                </div>
                <div>
                  <p className="font-bold text-stone-800 text-lg">Our Vision</p>
                  <p className="text-stone-500 text-sm">A Fair Jamaica For All</p>
                </div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div>
            <span className="inline-block text-emerald-600 font-semibold text-sm uppercase tracking-wider mb-4">
              Our Campaign
            </span>
            <h2 className="text-4xl sm:text-5xl font-bold text-stone-800 mb-6 leading-tight">
              A Call For <span className="text-emerald-600">Change</span>
            </h2>
            <p className="text-lg text-stone-600 mb-10 leading-relaxed">
              We are launching this humanitarian initiative to create lasting change 
              for Jamaican workers and families. Together, we can build a future of 
              dignity, fairness, and prosperity.
            </p>

            {/* Goals List */}
            <div className="space-y-5">
              {siteData.campaignGoals.map((goal, index) => (
                <div
                  key={index}
                  className="flex items-start gap-4 group"
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-emerald-100 flex items-center justify-center group-hover:bg-emerald-600 transition-colors">
                    <Check className="w-5 h-5 text-emerald-600 group-hover:text-white transition-colors" />
                  </div>
                  <p className="text-stone-700 leading-relaxed pt-1">
                    {goal}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
